
// DUCKS pattern
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState = {
	loading: false
};
// slice
export const ToastSlice = createSlice({
	name: "toast",
	initialState,
	reducers: {

		onSucc(state, action) {
			toast.success(action.payload);
		},
		onError(state, action) {
			toast.error(action.payload);
		},
		onWarn(state, action) {
			toast.warn(action.payload);
		}
	},
});

// Actions
export const toastAction = {
	onSuccToast: ToastSlice.actions.onSucc,
	onErrorToast: ToastSlice.actions.onError,
	onWarnToast: ToastSlice.actions.onWarn
};
export const { reducer: ToastSliceRe } = ToastSlice;